import CcmIcon from 'components/atoms/icons/ccmIcon';
import RpmIcon from 'components/atoms/icons/rpmIcon';
import { ModuleType } from 'infrastructure/enums';
import { Routes } from 'router/routes';

const PLATFORM_MODE_PATIENT_ACCEPTANCE = 'PATIENT_ACCEPTANCE';
const PLATFORM_MODE_ADMIN_PANEL_ACCESS = 'ADMIN-PANEL-ACCESS';
const PLATFORM_MODE_LOCALSTORAGE_KEY = 'EVELYN_PLATFORM_MODE';

const PLATFORM_CONFIG = {
  [ModuleType.CCM]: {
    dashboard: Routes.ccm,
    switch: ModuleType.RPM,
    icon: CcmIcon,
  },
  [ModuleType.RPM]: {
    dashboard: Routes.overviewDashboard,
    switch: ModuleType.CCM,
    icon: RpmIcon,
  },
  [PLATFORM_MODE_PATIENT_ACCEPTANCE]: {
    dashboard: Routes.adminPatients,
  },
  [PLATFORM_MODE_ADMIN_PANEL_ACCESS]: {
    dashboard: Routes.adminPatients,
  },
};

export {
  PLATFORM_MODE_PATIENT_ACCEPTANCE,
  PLATFORM_MODE_ADMIN_PANEL_ACCESS,
  PLATFORM_MODE_LOCALSTORAGE_KEY,
  PLATFORM_CONFIG,
};
